import { Box, Button, FormField, Select, Image, Stack } from "grommet";
import React from "react";
import { SDImage, ListImages } from "./ImagesStore";

const ImagesHome = () => {
    const [images, setImages] = React.useState([] as SDImage[]);

    React.useEffect(() => {
        ListImages().then((response) => {
            setImages(response.data);
        });
    }, []);

    return (
        <>
            <Box align="center" justify="center" direction="row" wrap gap="small">
                {images.map((image) => (
                    <Image key={image.id} src={"/api/images/" + image.id}></Image>
                ))}
            </Box>
        </>
    );
};

export default ImagesHome;
